// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ga3K","colBig":"styles_colBig__3NOp6","colSmall":"styles_colSmall__1BNiU"};